<template>
  <div v-if="!emailSent">
    <h1>{{ __('Personuppgifter') }}</h1>
    <div class="fix-width">
      <input
        type="email"
        v-model="$v.user.email.$model"
        :placeholder="__('E-post')"
      />
      <input
        type="number"
        v-model="$v.user.phone.$model"
        :placeholder="__('Telefonnummer')"
      />
      <input
        type="text"
        v-model="$v.user.country.$model"
        :placeholder="__('Land')"
      />
      <input
        type="password"
        v-model="$v.user.password.$model"
        :placeholder="__('Lösenord')"
      />
      <input
        type="password"
        v-model="$v.user.passwordConfirmed.$model"
        :placeholder="__('Repetera lösenord')"
        v-on:keyup.enter="signup"
      />
    </div>
    <div class="fix-width text-small margin-bottom-x3">
      {{
        __(
          'Om du vill veta mer om hur Equardian samlar in, använder, delar och skyddar dina personliga data kan du läsa Equardians'
        )
      }}
      <a href="https://equardian.com/privacy-policy/" target="_blank">{{
        __('sekretesspolicy')
      }}</a
      >.
    </div>

    <el-message warning v-if="warningMessage" class="margin-bottom-x2">
      {{ warningMessage }}
    </el-message>
    <el-message danger v-if="errorMessage" class="margin-bottom-x2">
      {{ errorMessage }}
    </el-message>
    <el-message info v-if="infoMessage" class="margin-bottom-x2">
      {{ infoMessage }}
    </el-message>

    <div class="row">
      <router-link to="/" class="button button-snd">
        {{ __('Tillbaka') }}
      </router-link>

      <button @click="signup" class="button" :disabled="$v.$invalid">
        {{ __('Fortsätt') }}
      </button>
    </div>
    <el-loader margin-top class="margin-bottom-x1" v-if="isLoading" />
  </div>
  <div v-else>
    <h1>{{ __('Registrering lyckades') }}!</h1>
    <p class="margin-bottom-x2">
      {{
        __('Vänligen klicka på länken vi skickat via e-post för att fortsätta.')
      }}
    </p>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import auth from 'services/auth.js'
import logScope from 'log-scope'
const log = logScope('Step1')

export default {
  data () {
    return {
      emailSent: false,
      warningMessage: '',
      infoMessage: '',
      errorMessage: '',
      isLoading: false,
      user: {
        email: '',
        phone: null,
        country: '',
        password: '',
        passwordConfirmed: '',
      },
    }
  },
  watch: {
    emailSent (val) {
      // TODO read url param to check if email link is clicked
      if (val) {
        let interval = setInterval(async () => {
          let user = await auth.getRefreshsedUser()
          if (!user || user === null) return

          let verifiedEmail = user.emailVerified

          if (verifiedEmail) {
            clearInterval(interval)
            // Go to page 2
            this.$emit('input', 2)
          }
        }, 2500)
      }
      // if (val) setTimeout(() => this.$emit('input', 2), 5000)
    },
  },
  validations: {
    user: {
      email: {
        required,
      },
      phone: {
        required,
      },
      country: {
        required,
      },
      password: {
        required,
      },
      passwordConfirmed: {
        required,
        // sameAsPassword: sameAs('password'), DENNA CHECK GÖRS I signup()
      },
    },
  },
  mounted () {
    this.user = {
      email: '',
      phone: null,
      country: '',
      password: '',
      passwordConfirmed: '',
    }
  },
  methods: {
    reset () {
      this.warningMessage = ''
      this.infoMessage = ''
      this.errorMessage = ''
    },

    // First we signup, then use the password to login
    async signup () {
      this.reset()

      if (
        this.user.email === '' ||
        this.user.password === '' ||
        this.user.passwordConfirmed === ''
      ) {
        this.warningMessage = this.__('Vänligen fyll i alla fält.')
        return
      }

      if (this.user.passwordConfirmed !== this.user.password) {
        this.warningMessage = this.__('Lösenorden stämmer inte överens.')
        return
      }

      this.isLoading = true

      try {
        await auth.registerAsync(this.user)
        await auth.loginAsync(this.user.email, this.user.password)
        this.isLoading = false
        this.emailSent = true
        return
        // this.$router.replace('/')
      } catch (err) {
        this.isLoading = false
        this.errorMessage = this.__(err.message || err)
        log.error('Could not log in', err)
      }
    },
  },
}
</script>
